import { render, staticRenderFns } from "./ListFeedback.vue?vue&type=template&id=00957759&scoped=true"
import script from "./ListFeedback.vue?vue&type=script&lang=js"
export * from "./ListFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00957759",
  null
  
)

export default component.exports